<template>
  <div class="relative w-full overflow-hidden">
    <NuxtImg
      :src="url"
      :alt="alt"
      class="absolute h-full w-full object-cover object-center"
      :class="imageClass"
      loading="lazy"
      :width="width"
      :height="height"
      :sizes="sizes"
      :fit="fit"
      :format="format"
    />
  </div>
</template>

<script setup lang="ts">
import NuxtImg from './NuxtImg.vue'

defineProps({
  imageClass: [String, Array],
  url: String,
  format: String,
  alt: String,
  srcset: String,
  // Without sizes, NuxtImg requests the untransformed original (often several MB).
  sizes: { type: String, default: 'xs:100vw xl:1280px' },
  fit: String,
  width: [String, Number],
  height: [String, Number],
})
</script>
